/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
import './hrAgent.css';

function HrAgent() {
  const formRef = useRef();
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    let timeout;

    if (submitted || error) {
      timeout = setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 5000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [submitted, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSfQZ61y0foHfRHJHIfH11I59OSMe3zBMS5_uzxZ4Gy1-Y8Tug/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        },
      );

      setSubmitted(true);
      setError(false);
      formRef.current.reset(); // optional: reset the form after submit
    } catch (error) {
      console.error('Form submission error:', error);
      setError(true);
      setSubmitted(false);
    }
  };

  return (
    <div className="english-agent-container">
      <div className="container">
        <div className="form-container">
          <h1 className="form-title">HR Feedback Agent</h1>
          <div className="form-intro">
            <p>
              This agent is a
              <strong> DEMO </strong>
              product built for HR consultants that want to integrate smart tech features directly into their websites.
            </p>

            <p>
              After submitting the form, this assistant will generate a unique, customized resume feedback and new improved proposal based on your input and send it straight to your email.
              <strong> Please enter the email address where you`d like to receive your post.</strong>
            </p>

            <p>
              <i>
                *Each agents logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, you`re instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to request history.
              </i>
            </p>

            <p>
              <strong>NOTE: </strong>
              If you`d like to learn more on how to offer this experience to your own clients or website visitors, you can book a meeting with me here:
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer"> Calendly.</a>
              <div>
                <br />
                {/* <a href="https://www.loom.com/share/YOUR-VIDEO-ID-HERE" target="_blank" rel="noopener noreferrer">Watch the quick explainer video.</a> */}
              </div>
            </p>
          </div>

          <form className="form" onSubmit={handleSubmit} ref={formRef}>
            {/* Email Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="entry.1432547003"
                  required
                  className="form-input"
                  placeholder="tim@apple.com"
                />
                <label htmlFor="email" className="select-label required">
                  Email
                </label>
              </div>
            </div>

            {/* targetJobTitle Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="targetJobTitle"
                  name="entry.604645151"
                  required
                  className="form-input"
                  placeholder="Product Manager."
                />
                <label htmlFor="targetJobTitle" className="select-label required">
                  Target Job Title
                </label>
              </div>
            </div>

            {/* industry Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="industry"
                  name="entry.1401928178"
                  required
                  className="form-input"
                  placeholder="Technology"
                />
                <label htmlFor="industry" className="select-label required">
                  Industry
                </label>
              </div>
            </div>

            {/* years of experience Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="years_experience"
                  name="entry.241611247"
                  required
                  className="form-input"
                  placeholder="3 years"
                />
                <label htmlFor="years_experience" className="select-label required">
                  Years of Experience
                </label>
              </div>
            </div>

            {/* changingIndustry Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="changingIndustry"
                  name="entry.1371417123"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <label htmlFor="changingIndustry" className="select-label required">
                  Changing Industry
                </label>
              </div>
            </div>

            {/* changingRole Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="changingRole"
                  name="entry.906950249"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <label htmlFor="changingRole" className="select-label required">
                  Changing Role
                </label>
              </div>
            </div>

            {/* Context Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="context"
                  name="entry.1430263335"
                  required
                  className="form-input"
                  placeholder="Looking for a career change from product analyst to sales."
                />
                <label htmlFor="context" className="select-label required">
                  Current context
                </label>
              </div>
            </div>

            {/* About Field (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="about"
                  name="entry.1257707571"
                  required
                  className="form-textarea"
                  placeholder="Ex.: Add or paste here your About section from resume or LinkedIn."
                  rows="4"
                />
                <label htmlFor="about" className="select-label required">
                  About
                </label>
              </div>
            </div>

            {/* lastExperience Field (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="lastExperience"
                  name="entry.1680875765"
                  required
                  className="form-textarea"
                  placeholder="Ex.: Add or paste here your 3 to 5 key highlights of your most recent experience."
                  rows="4"
                />
                <label htmlFor="lastExperience" className="select-label required">
                  Most Recent Experience
                </label>
              </div>
            </div>

            {/* secondLastExperience Field (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="secondLastExperience"
                  name="entry.1746943363"
                  className="form-textarea"
                  placeholder="Ex.: Write N/A if not applicable"
                  rows="4"
                />
                <label htmlFor="secondLastExperience" className="select-label required">
                  Second Most Recent Experience
                </label>
              </div>
            </div>

            {/* thirdLastExperience Field (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="thirdLastExperience"
                  name="entry.1193774854"
                  className="form-textarea"
                  placeholder="Ex.: Write N/A if not applicable"
                  rows="4"
                />
                <label htmlFor="thirdLastExperience" className="select-label required">
                  Third Most Recent Experience
                </label>
              </div>
            </div>

            {/* fourthLastExperience Field (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="fourthLastExperience"
                  name="entry.1879837996"
                  className="form-textarea"
                  placeholder="Ex.: Write N/A if not applicable"
                  rows="4"
                />
                <label htmlFor="fourthLastExperience" className="select-label required">
                  Fourth Most Recent Experience
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By submitting this form, you agree to be contacted via email with your personalized content and occasional updates related to this service.</p>
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
              <div className="submit-button-response">
                {submitted && (
                  <div className="form-success-message">
                    🎉 Thanks! Your response has been submitted.
                  </div>
                )}

                {error && (
                <div className="form-error-message">
                  ❌ Oops! Something went wrong. Please try again in a few seconds.
                </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default HrAgent;
